import * as React from "react";
import ReactMarkdown from "react-markdown";
import { ICompasAIChatAction } from "@/types/compass.types";
import { getMarkdownColorClass } from "./action-item.utils";

interface ActionItemContentDisplayProps {
  action: ICompasAIChatAction;
  isExpanded: boolean;
  currentStatus: string;
}

export const ActionItemContentDisplay: React.FC<ActionItemContentDisplayProps> = ({
  action,
  isExpanded,
  currentStatus,
}) => (
  <div
    style={{ wordBreak: "break-word" }}
    className={`prose prose-sm max-w-none ${getMarkdownColorClass(currentStatus)}`}
  >
    <ReactMarkdown
      components={{
        a: ({ node: _node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer" />
        ),
      }}
    >
      {isExpanded
        ? action.prompt
        : action.prompt && action.prompt.length > 150
          ? action.prompt.substring(0, 150) + "..."
          : action.prompt}
    </ReactMarkdown>
  </div>
);
